import React from 'react'
import { Route } from 'react-router-dom'
import { Layout as SideBarLayout } from 'pages'

export default ({ component: Component, layout: Layout = SideBarLayout, ...rest }) => (
  <Route {...rest} render={props => (
    <Layout>
      <Component {...props} />
    </Layout>
  )} />
)
